import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

const NotificationsTab = () => {
  const preferences = [
    {
      id: "placement",
      label: "New Placements",
      desc: "Get notified when students are placed",
    },
    {
      id: "internship",
      label: "Internship Applications",
      desc: "Get notified about new internship applications",
    },
    {
      id: "vendor",
      label: "Vendor Updates",
      desc: "Get notified about vendor activities",
      checked: false,
    },
    {
      id: "enrollment",
      label: "Student Enrollments",
      desc: "Get notified about new student enrollments",
    },
    {
      id: "email",
      label: "Email Notifications",
      desc: "Receive notifications via email",
    },
  ];

  return (
    <Card className="border-none shadow-sm">
      <CardHeader className="border-b border-gray-50 pb-3">
        <CardTitle className="text-lg font-bold">
          Notification Preferences
        </CardTitle>
        <p className="text-xs font-medium tracking-tight text-gray-500">
          Choose what notifications you want to receive
        </p>
      </CardHeader>
      <CardContent className="space-y-6 pt-6">
        {preferences.map((pref) => (
          <div
            key={pref.id}
            className="group flex items-center justify-between"
          >
            <div className="space-y-0.5">
              <Label className="cursor-pointer text-sm font-bold text-gray-800">
                {pref.label}
              </Label>
              <p className="text-xs font-medium tracking-tight text-gray-400">
                {pref.desc}
              </p>
            </div>
            <Switch defaultChecked={pref.checked !== false} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default NotificationsTab;
